export default function scrollIt() {
  const $ = require('jquery');

  $('.scroll-it').bind('click', function(event) {
    var $anchor = $(this);

    // if ($(window).width() >= 1200) {
    $('html, body')
      // .stop()
      .animate(
        {
          scrollTop: $($anchor.attr('href')).offset().top - 90
        },
        500
      );

    event.preventDefault();
    // }

    // if ($(window).width() >= 768) {
    //   $('html, body')
    //     .stop()
    //     .animate(
    //       {
    //         scrollTop: $($anchor.attr('href')).offset().top - 75
    //       },
    //       1000,
    //       'easeInOutExpo'
    //     );

    //   event.preventDefault();
    // }

    // if ($(window).width() < 768) {
    //   $('html, body')
    //     .stop()
    //     .animate(
    //       {
    //         scrollTop: $($anchor.attr('href')).offset().top - 90
    //       },
    //       1000,
    //       'easeInOutExpo'
    //     );

    //   event.preventDefault();
    // }
  });
}
